enum ClassificationMethod {
  EQUAL_INTERVAL = "equalInterval",
  NATURAL_BREAKS = "naturalBreaks",
  QUANTILE = "quantile",
}

export default ClassificationMethod;
